import { db } from "@/firebase";

export default {
    methods: {
        async _getCurrentLanguageIndex(customerID, currentLanguageCountryCode) {
          if (!customerID || !currentLanguageCountryCode) {
            return 0;
          }
          const languages = (await db.ref(`customers/${customerID}/languageTypes`).once('value')).val();

          if (languages && languages.length) {
            const index = languages.findIndex((language) => language === currentLanguageCountryCode);
            return index >= 0 ? index : 0;
          }

          return 0;
        }
    },
};